import React, { useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import Card from "../../UI/Card";
import { Link } from "react-router-dom";

const PowerFull = () => {
  const [data] = useState([
    {
      title: "Commercial Property & Unit Management",
      icon: "/assets/home/control2.svg",
      desc: "Create, configure, and manage every commercial unit in your flex space or small bay industrial portfolio from a single dashboard.",
    },
    {
      title: "Automated Rent Collection",
      icon: "/assets/home/control1.svg",
      desc: "No more chasing payments. Collect commercial rent on autopilot with ACH, card, and check — with built-in late-fee enforcement.",
    },
    {
      title: "Maintenance Scheduling",
      icon: "/assets/home/control3.svg",
      desc: "Log, assign, and close maintenance requests in minutes. Keep every industrial unit in top condition with full audit trails.",
    },
    {
      title: "Tenant Communication",
      icon: "/assets/home/control4.svg",
      desc: "Send broadcast messages, lease reminders, and notices directly through the platform — all with a complete message history.",
    },
  ]);

  return (
    <div className="w-[90%] mx-auto mt-20">
      {/* Section label */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <p className="text-center font-popinsMedium text-sm uppercase tracking-widest text-paraColor mb-3">
          Platform Capabilities
        </p>

        <h2 className="text-btnColor font-popinsBold text-3xl md:text-4xl lg:text-5xl xl:text-6xl text-center leading-tight">
          Powerful Tools. Seamless Control.
        </h2>
        <p className="text-paraColor font-popinsRegular text-base md:text-lg text-center w-[90%] lg:w-[55%] mx-auto mt-4 leading-relaxed">
          Everything a commercial industrial property operator needs — built specifically
          for flex space, multi-tenant warehouses, and small bay portfolios.
        </p>
      </motion.div>

      <motion.div
        className="bg-themeColor rounded-2xl px-6 py-10 lg:py-12 mt-10"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.65, ease: "easeOut" }}
      >
        <div className="flex justify-between items-center mb-10">
          <div>
            <h5 className="font-popinsBold text-white text-2xl md:text-3xl">
              Core Features
            </h5>
            <p className="font-popinsRegular text-white/70 text-sm mt-1">
              Purpose-built for commercial small bay &amp; flex industrial operators
            </p>
          </div>
          <Link
            to="/features/tenant-management"
            className="bg-white/10 hover:bg-white/20 border border-white/30 rounded-full p-2 transition-all duration-200"
            aria-label="View all features"
          >
            <ArrowUpRight className="text-white w-5 h-5" />
          </Link>
        </div>
        <Card data={data} />
      </motion.div>
    </div>
  );
};

export default PowerFull;
